<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<g>
			<path d="M151.048,286.4c-5.376,0.624-10.032,3.896-12.408,8.656c-11.505,22.341-23.004,44.737-34.452,67.124l-30.7-46.884
				c-3.048-4.648-3.488-10.44-1.184-15.48l31.368-68.192c11.12-25.992,10.344-47.648-2.032-65.712l-7.6-13.136
				c-2.936-5.064-8.48-8.28-14.232-7.936c-5.896,0.16-11.224,3.536-13.936,8.888L7.712,271.16
				c-5.152,10.4-7.392,21.944-6.488,33.376L12.957,456H8c-4.416,0-8,3.576-8,8v40c0,4.424,3.584,8,8,8h136c4.416,0,8-3.576,8-8v-40
				c0-4.424-3.584-8-8-8h-1.7c4.259-25.187,13.546-50.965,29.532-82.2c15.848-30.984,13.72-56.976-6.744-81.816
				C161.64,287.864,156.408,285.8,151.048,286.4z M136,496H16v-24h120V496z M157.592,366.512
				c-17.32,33.83-27.179,61.775-31.509,89.488H29.004L17.176,303.288c-0.68-8.56,1.008-17.208,4.872-25.024L80.2,160.808
				l7.912,13.632c9.488,13.88,9.76,30.056,0.936,50.696L57.76,293.152c-4.608,10.08-3.736,21.64,2.344,30.912l35.685,54.498
				c-3.847,7.462-7.694,14.958-11.541,22.462l-1.216,2.368c-2.016,3.936-0.464,8.752,3.472,10.768
				c3.936,2.032,8.752,0.464,10.768-3.472l1.216-2.368c4.504-8.802,9.016-17.603,13.543-26.365c0.048-0.086,0.091-0.175,0.135-0.263
				c13.515-26.455,27.11-52.925,40.61-79.484C169.088,322.008,170.52,341.232,157.592,366.512z"/>
			<path d="M504,456h-4.965l11.733-151.448c0.904-11.448-1.336-22.992-6.488-33.384l-58.192-117.504
				c-2.68-5.288-8.008-8.656-13.904-8.824c-5.904-0.344-11.296,2.872-14.232,7.944l-7.28,12.616
				c-12.696,18.576-13.464,40.232-2.264,66.416L439.68,299.8c2.312,5.056,1.872,10.848-1.176,15.496l-30.687,46.864
				c-11.45-22.387-22.945-44.765-34.409-67.016c-2.424-4.848-7.08-8.12-12.456-8.744c-5.336-0.6-10.592,1.464-14.08,5.632
				c-20.424,24.8-22.552,50.784-6.704,81.776c15.979,31.229,25.266,57,29.53,82.192H368c-4.416,0-8,3.576-8,8v40
				c0,4.424,3.584,8,8,8h136c4.416,0,8-3.576,8-8v-40C512,459.576,508.416,456,504,456z M354.424,366.52
				c-12.936-25.296-11.496-44.52,4.72-64.136c13.515,26.243,27.038,52.566,40.499,78.92c0.122,0.278,0.262,0.547,0.416,0.81
				c4.49,8.69,8.972,17.447,13.461,26.206l1.216,2.368c2.008,3.944,6.832,5.496,10.768,3.472c3.936-2.016,5.48-6.84,3.472-10.768
				l-1.216-2.368c-3.86-7.517-7.707-15.017-11.549-22.474l35.677-54.486c6.072-9.272,6.952-20.824,2.336-30.928l-31.192-67.808
				c-8.912-20.84-8.64-37.008,1.168-51.4l7.592-13.104l58.16,117.448c3.872,7.808,5.552,16.456,4.872,25.032L482.996,456h-97.063
				C381.602,428.294,371.744,400.349,354.424,366.52z M496,496H376v-24h120V496z"/>
			<path d="M369.136,215.192c1.504-1.496,2.344-3.528,2.344-5.656s-0.84-4.152-2.344-5.656l-14.688-14.688
				c3.664-6.752,6.608-13.848,8.8-21.192H384c4.416,0,8-3.576,8-8v-48c0-4.424-3.584-8-8-8h-20.752
				c-2.192-7.344-5.136-14.432-8.8-21.192l14.688-14.688c3.128-3.128,3.128-8.184,0-11.312l-33.944-33.944c-3-3-8.312-3-11.312,0
				l-14.688,14.688c-6.76-3.664-13.856-6.608-21.192-8.8V8c0-4.424-3.584-8-8-8h-48c-4.416,0-8,3.576-8,8v20.752
				c-7.336,2.2-14.432,5.136-21.192,8.8L188.12,22.864c-3-3-8.312-3-11.312,0l-33.944,33.944c-3.128,3.128-3.128,8.184,0,11.312
				l14.688,14.688c-3.664,6.752-6.608,13.848-8.8,21.192H128c-4.416,0-8,3.576-8,8v48c0,4.424,3.584,8,8,8h20.752
				c2.192,7.344,5.136,14.432,8.8,21.192l-14.688,14.688c-1.504,1.496-2.344,3.528-2.344,5.656c0,2.128,0.84,4.152,2.344,5.656
				l33.944,33.936c3.128,3.128,8.184,3.128,11.312,0l14.688-14.68c6.76,3.664,13.856,6.608,21.192,8.8V264c0,4.424,3.584,8,8,8h48
				c4.416,0,8-3.576,8-8v-20.752c7.336-2.2,14.432-5.136,21.192-8.8l14.688,14.68c3.128,3.128,8.184,3.128,11.312,0L369.136,215.192
				z M316.168,218.8c-2.616-2.64-6.688-3.104-9.856-1.152c-8.744,5.392-18.216,9.32-28.152,11.68
				c-3.616,0.856-6.16,4.072-6.16,7.784V256h-31.992v-18.888c0-3.712-2.552-6.936-6.16-7.784c-9.936-2.36-19.408-6.288-28.152-11.68
				c-3.16-1.96-7.232-1.472-9.856,1.152l-13.376,13.368l-22.632-22.624l13.376-13.376c2.624-2.624,3.096-6.696,1.152-9.856
				c-5.4-8.744-9.328-18.216-11.68-28.152c-0.856-3.616-4.08-6.16-7.784-6.16H136v-32h18.888c3.704,0,6.928-2.552,7.784-6.16
				c2.352-9.944,6.28-19.408,11.68-28.152c1.944-3.152,1.472-7.232-1.152-9.856l-13.376-13.376l22.632-22.632L195.832,53.2
				c2.624,2.632,6.688,3.104,9.856,1.152c8.744-5.392,18.216-9.32,28.152-11.68c3.616-0.856,6.16-4.072,6.16-7.784V16h32v18.888
				c0,3.712,2.544,6.936,6.16,7.784c9.936,2.36,19.408,6.288,28.152,11.68c3.168,1.96,7.24,1.48,9.856-1.152l13.368-13.376
				l22.632,22.632l-13.376,13.376c-2.624,2.624-3.096,6.696-1.152,9.856c5.4,8.744,9.328,18.216,11.68,28.152
				c0.856,3.616,4.08,6.16,7.784,6.16H376v32h-18.888c-3.704,0-6.928,2.552-7.784,6.16c-2.352,9.944-6.28,19.408-11.68,28.152
				c-1.944,3.152-1.472,7.232,1.152,9.856l13.376,13.376l-22.632,22.624L316.168,218.8z"/>
			<path d="M256,72c-35.288,0-64,28.712-64,64c0,35.288,28.712,64,64,64c35.288,0,64-28.712,64-64C320,100.712,291.288,72,256,72z
				 M256,184c-26.472,0-48-21.528-48-48s21.528-48,48-48s48,21.528,48,48S282.472,184,256,184z"/>
		</g>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
